import { render } from "./Data7.vue?vue&type=template&id=3735d007"
import script from "./Data7.vue?vue&type=script&lang=js"
export * from "./Data7.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__